import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAuth } from "./axiosInstance";

export const fetchCourseList = createAsyncThunk(
    'courseList/fetchCourseList',
    async ({ uid }) => {      
        try {
            const response = await axiosAuth.post('https://ninjacurate.learntube.ai/fetch_user_course_names', { uid: uid });
            return response.data;
        } catch (err) {
            console.log(err);
            throw err;
        }
    }
);

export const fetchNextModuleStatus = createAsyncThunk(
    'courseList/fetchNextModuleStatus',
    async ({ user_id, course_name, module_number }) => {
        try {
            const response = await axiosAuth.get(
                'https://ninjacurate.learntube.ai/curate_next_module_status',
                {
                    params: {
                        user_id,
                        course_name,
                        module_number,
                    },
                }
            );
            return response.data;
        } catch (err) {
            console.log(err);
            throw err;
        }
    }
);

export const curateNextModule = createAsyncThunk(
    'courseList/curateNextModule',
    async ({ user_id, course_name, module_number, course_language = 'en' }) => {
        try {
            const response = await axiosAuth.post(
                'https://ninjacurate.learntube.ai/curate_next_module',
                {
                    user_id,
                    courseName: course_name,
                    module_number,
                    course_language,
                }
            );
            return response.data;
        } catch (err) {
            console.log(err);
            throw err;
        }
    }
);

const courseListSlice = createSlice({
    name: 'courseList',
    initialState: {
        courseName: "",
        subject_names: [],
        nextModuleStatus: null,
        nextModuleStatusLoading: false,
        nextModuleStatusError: null,
    },
    reducers: {
        updateCourseName: (state, action) => {
            state.courseName = action.payload;
        },
        resetNextModuleStatus: (state) => {
            state.nextModuleStatus = null;
            state.nextModuleStatusLoading = false;
            state.nextModuleStatusError = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCourseList.fulfilled, (state, action) => {
                state.subject_names = action?.payload?.subject_names;
            })
            .addCase(fetchNextModuleStatus.pending, (state) => {
                state.nextModuleStatusLoading = true;
                state.nextModuleStatusError = null;
            })
            .addCase(fetchNextModuleStatus.fulfilled, (state, action) => {
                state.nextModuleStatusLoading = false;
                state.nextModuleStatus = action.payload;
            })
            .addCase(fetchNextModuleStatus.rejected, (state, action) => {
                state.nextModuleStatusLoading = false;
                state.nextModuleStatusError = action.error;
            });
    },
});

export const { updateCourseName, resetNextModuleStatus } = courseListSlice.actions
export const selectCourseList = (state) => state.personaliseLessons?.courseList;
export default courseListSlice.reducer;